import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Kun je trainen als je spierpijn hebt?</title>
                <link rel="canonical" href={route("blogs.fifth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Je hebt een hele zware workout gedaan waarvan je dagenlang nog last hebt. Het is inmiddels een paar dagen later en je was eigenlijk van plan om weer te gaan trainen. Is dit dan wel verstandig als je nog spierpijn hebt van de vorige training?"
                />
                <meta
                    property="og:description"
                    content="Je hebt een hele zware workout gedaan waarvan je dagenlang nog last hebt. Het is inmiddels een paar dagen later en je was eigenlijk van plan om weer te gaan trainen. Is dit dan wel verstandig als je nog spierpijn hebt van de vorige training?"
                />
                <meta property="og:url" content={route("blogs.fifth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Kun je trainen als je spierpijn hebt? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/kun-je-trainen-als-je-spierpijnt-hebt.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/kun-je-trainen-als-je-spierpijn-hebt.webp"
                                    type="image/webp"
                                    alt="Trainen bij spierpijn"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/kun-je-trainen-als-je-spierpijn-hebt.jpg"
                                    type="image/jpeg"
                                    alt="Trainen bij spierpijn"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/kun-je-trainen-als-je-spierpijn-hebt.jpg"
                                    alt="Trainen bij spierpijn"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Kun je trainen als je spierpijn hebt?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Je hebt een hele zware workout gedaan waarvan je
                        dagenlang nog last hebt. Het is inmiddels een paar dagen
                        later en je was eigenlijk van plan om weer te gaan
                        trainen. Is dit dan wel verstandig als je nog spierpijn
                        hebt van de vorige training?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is spierpijn?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Allereerst zijn er verschillende soorten spierpijn. Je
                        hebt namelijk vroege- en verlate spierpijn. Deze hebben
                        andere oorzaken en daarom zullen we deze apart
                        uitleggen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Vroege spierpijn ontstaat tijdens het sporten. Bij een
                        intensieve inspanning is er veel energie nodig. Bij het
                        verbranden van energie komen afvalstoffen zoals melkzuur
                        vrij in de spieren. Bij een te hoge of lange intensieve
                        inspanning kunnen die afvalstoffen niet meer afgevoerd
                        worden. Hierdoor treed verzuring op. Ken je het gevoel
                        dat je spieren als harde bakstenen voelen? Dat noemen we
                        dus vroege spierpijn.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Verlate spierpijn zul je veelal voelen 24 á 48 uur na de
                        training. Deze word ook wel DOMS genoemd, wat staat voor
                        delayed onset of muscle fatigue. Dit is de spierpijn die
                        je de dagen na de training voelt. Deze ontstaat doordat
                        er minuscule spierscheurtjes ontstaan in het bindweefsel
                        van de spieren. Hierdoor ontstaat verlate spierpijn.
                        Deze scheurtjes moeten weer hersteld worden door het
                        lichaam. Dit zorgt ervoor dat de spieren weer sterker
                        worden.
                    </p>
                    <p className="mt-4 text-gray-100 break-words"></p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Kun je spierpijn voorkomen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn manieren voor om te gaan met spierpijn, maar
                        helemaal voorkomen is bijna niet mogelijk. Zo helpt een
                        goede warming-up voor de training. Tijdens het trainen
                        is het belangrijk om voldoende water te drinken. Dit
                        zorgt ervoor dat de afvalstoffen beter kunnen worden
                        afgevoerd. Verder kun je na de training rekoefeningen of
                        een cooling down doen. Een massage of warme douche na de
                        training zou de spierpijn ook licht kunnen verminderen.
                        Dit zorgt namelijk voor een betere doorbloeding van de
                        spieren.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ook voeding speelt een belangrijke rol bij het
                        verminderen van de spierpijn. De verlate spierpijn
                        ontstaat dus door minuscule spierscheurtjes. Om deze te
                        herstellen heeft je lichaam eiwitten nodig. Zorg er dus
                        voor dat je voldoende eiwitten binnenkrijgt.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Kun je trainen met spierpijn?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je nog verlate spierpijn ervaart betekent dit dat er
                        nog scheurtjes aanwezig zijn in de spieren. Dan zou je
                        zeggen dat het niet verstandig is om weer te gaan
                        trainen. Dit is niet helemaal waar. Het kan juist goed
                        zijn om weer te gaan trainen als je nog lichte spierpijn
                        hebt. Deze training stimuleert de doorbloeding wat goed
                        is voor het spierherstel.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je weer gaat trainen is het wellicht verstandig om
                        iets lichtere gewichten te gebruiken of eventueel de
                        spiergroepen te trainen waar je geen spierpijn ervaart.
                        Zo blijf je actief bezig en krijgt je lichaam
                        tegelijkertijd nog voldoende rust om te herstellen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Spierpijn zal op het begin van een trainingsschema het
                        ergste zijn. Na verloop van tijd zal de spierpijn steeds
                        minder worden. Blijf je toch veel last houden van
                        verlate spierpijn? Dan kan het zijn dat je bepaalde
                        spiergroepen te vaak in de week traint en ze daardoor
                        onvoldoende tijd hebben om te kunnen herstellen. Pas in
                        dit geval je trainingsschema aan zodat je de
                        spiergroepen twee of drie keer in de week traint. In dat
                        geval zal er voldoende tijd zijn voor je spieren om te
                        herstellen.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
